// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../svg/arrowDown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-white-2: #fbfcfe;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-5: #0042a6;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-09: #ccedff;
  --color-mima-light: #eef2f5;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffaa00;
  --color-yellow-3: #8f4f00;
  --color-light-red: #f7d1cd;
  --color-deep-red: #9f0000;
  --color-grey: #b3b3c5;
  --color-grey-2: #d1d1d1;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #d1d1d1;
  --color-grey-5: #ebebf5;
  --color-grey-6: #9898ab;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #4a4a68;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-6: #2a2828;
  --color-disabled: #c0c0c0;
  --color-light-blue: #ebf2ff;
  --color-light-blue-2: #d4e5ff;
  --color-light-blue-3: #e7f3fe;
  --color-dark-yellow: #7e6e1f;
  --color-light-brown: #f4f5f6;
  --color-light-green: #e4ffec;
  --color-light-yellow: #fff5d7;
  --color-light-red: #ffe8e8;
  --color-light-grey: #f3f3ff;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
}

.MimaDropdown_label__Xurff {
  font-size: 1.4rem;
  font-family: inherit;
  padding-left: 2rem;
  margin-bottom: 1rem;
  width: 100%;
  display: flex;
  max-width: 38rem;
}
.MimaDropdown_label__wide__72MNG {
  font-size: 1.4rem;
  font-family: inherit;
  margin-bottom: 1rem;
  padding-left: 2rem;
}

.MimaDropdown_select__dhfeg {
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 3rem;
  color: #4a4a68;
}
.MimaDropdown_select__options__xLi7K {
  padding: 1.5rem 2rem;
  cursor: pointer;
}
.MimaDropdown_select__options__xLi7K:hover {
  background-color: #1f68d6;
  color: #ffffff;
}
.MimaDropdown_select__options_selected__1Ic9v {
  padding-left: 2rem;
  padding-top: 1.9rem;
  width: 38rem;
  height: 6rem;
  border-radius: 1rem;
  background-color: #ffffff;
  border: 1px solid #4a4a68;
  display: block;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  color: #4a4a68;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  order: 0;
  position: relative;
}
.MimaDropdown_select__options_selected__1Ic9v::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 1.6rem;
  right: 2rem;
  top: 2.5rem;
  transition: all 0.4s;
}
.MimaDropdown_select__options_selected__wide__uJhGk {
  padding-left: 2rem;
  width: 100%;
}
.MimaDropdown_select__options_active__bNzTz + .MimaDropdown_select__options_selected__1Ic9v::after {
  transform: rotateX(180deg);
  top: -2.5rem;
}
.MimaDropdown_select__options_container__KYLP5 {
  background-color: #ffffff;
  color: #4a4a68;
  border: 1px solid #4a4a68;
  width: 38rem;
  border-radius: 1rem;
  transition: all 0.4s;
  order: 1;
  max-height: 27rem;
  overflow-y: scroll;
}
.MimaDropdown_select__options_container__KYLP5::-webkit-scrollbar {
  width: 1rem;
  background-color: #ffffff;
  border-radius: 0 1rem 1rem 0;
}
.MimaDropdown_select__options_container__KYLP5::-webkit-scrollbar-thumb {
  background-color: #b3b3c5;
  border-radius: 1rem;
}
.MimaDropdown_select__options_container__wide__DveW- {
  width: 60rem;
}
@media only screen and (max-width: 31.25em) {
  .MimaDropdown_select__options_container__wide__DveW- {
    width: 38rem;
  }
}
.MimaDropdown_select__options_active__bNzTz {
  opacity: 1;
  max-height: 27rem;
  overflow-y: scroll;
}
.MimaDropdown_select__options_label__vZRRu {
  cursor: pointer;
}

.MimaDropdown_select2__WC\\+vJ {
  display: flex;
  width: 18rem;
  flex-direction: column;
  margin-top: 3rem;
  color: #4a4a68;
}
.MimaDropdown_select2__options__QYoIu {
  padding: 1.5rem 2rem;
  cursor: pointer;
}
.MimaDropdown_select2__options__QYoIu:hover {
  background-color: #1f68d6;
  color: #ffffff;
}
.MimaDropdown_select2__options_selected__TI9ZR {
  padding-left: 2rem;
  padding-top: 0.9rem;
  font-size: var(--default-font-small);
  width: 18rem;
  height: 4rem;
  border-radius: 1rem;
  background-color: #ffffff;
  border: 1px solid #4a4a68;
  display: block;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  color: #4a4a68;
  margin-top: 0.5rem;
  order: 0;
  position: relative;
}
.MimaDropdown_select2__options_selected__TI9ZR::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 1.6rem;
  right: 2rem;
  top: 1.5rem;
  transition: all 0.4s;
}
.MimaDropdown_select2__options_selected__wide__2eROH {
  padding-left: 2rem;
  width: 100%;
}
.MimaDropdown_select2__options_active__jr8lX + .MimaDropdown_select2__options_selected__TI9ZR::after {
  transform: rotateX(180deg);
  top: -2.5rem;
}
.MimaDropdown_select2__options_container__qzUuM {
  background-color: #ffffff;
  color: #4a4a68;
  border: 1px solid #4a4a68;
  width: 18rem;
  border-radius: 1rem;
  transition: all 0.4s;
  order: 1;
  max-height: 27rem;
  overflow-y: scroll;
  font-size: var(--default-font-small);
}
.MimaDropdown_select2__options_container__qzUuM::-webkit-scrollbar {
  width: 1rem;
  background-color: #ffffff;
  border-radius: 0 1rem 1rem 0;
}
.MimaDropdown_select2__options_container__qzUuM::-webkit-scrollbar-thumb {
  background-color: #b3b3c5;
  border-radius: 1rem;
}
.MimaDropdown_select2__options_container__wide__-\\+qxN {
  width: 38rem;
}
@media only screen and (max-width: 31.25em) {
  .MimaDropdown_select2__options_container__wide__-\\+qxN {
    width: 18rem;
  }
}
.MimaDropdown_select2__options_active__jr8lX {
  opacity: 1;
  max-height: 27rem;
  overflow-y: scroll;
}
.MimaDropdown_select2__options_label__7f\\+Pg {
  cursor: pointer;
}

.MimaDropdown_filled__9OL8h {
  color: #4a4a68;
}

.MimaDropdown_error__3x5pG {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
  max-width: 38rem;
}

.MimaDropdown_success__h3__HAymX {
  color: var(--color-success);
  font-size: var(--default-font-h3);
  font-weight: 700;
  line-height: 3.5rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/assets/styles/MimaDropdown.module.scss"],"names":[],"mappings":"AAAA;EAEC,sBAAA;EACA,sBAAA;EACA,wBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAGA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;ACTD;;AArDA;EACC,iBDmGoB;EClGpB,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AAwDD;AAtDC;EACC,iBD0FmB;ECzFnB,oBAAA;EAEA,mBAAA;EACA,kBAAA;AAwDF;;AApDA;EACC,aAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,cDmEY;ACZb;AArDC;EACC,oBAAA;EACA,eAAA;AAuDF;AArDE;EACC,yBDwCa;ECvCb,cDoCW;ACmBd;AApDE;EAEC,kBAAA;EACA,mBAAA;EAEA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBDyBW;ECxBX,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,cD0CU;ECzCV,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAoDH;AAlDG;EACC,WAAA;EACA,mDAAA;EACA,wBAAA;EACA,4BAAA;EAEA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EAEA,oBAAA;AAkDJ;AA/CG;EACC,kBAAA;EACA,WAAA;AAiDJ;AA7CE;EACC,0BAAA;EACA,YAAA;AA+CH;AA5CE;EACC,yBDdW;ECeX,cDQU;ECPV,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AA8CH;AA5CG;EACC,WAAA;EACA,yBD1BU;EC2BV,4BAAA;AA8CJ;AA3CG;EACC,yBDdS;ECeT,mBAAA;AA6CJ;AA1CG;EACC,YAAA;AA4CJ;AA3CI;EAFD;IAGE,YAAA;EA8CH;AACF;AA1CE;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;AA4CH;AAzCE;EACC,eAAA;AA2CH;;AAtCA;EACC,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,cDrCY;AC8Eb;AAvCC;EACC,oBAAA;EACA,eAAA;AAyCF;AAvCE;EACC,yBDhEa;ECiEb,cDpEW;AC6Gd;AAtCE;EAEC,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBD/EW;ECgFX,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,cD9DU;EC+DV,kBAAA;EACA,QAAA;EACA,kBAAA;AAuCH;AArCG;EACC,WAAA;EACA,mDAAA;EACA,wBAAA;EACA,4BAAA;EAEA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EAEA,oBAAA;AAqCJ;AAlCG;EACC,kBAAA;EACA,WAAA;AAoCJ;AAhCE;EACC,0BAAA;EACA,YAAA;AAkCH;AA/BE;EACC,yBDrHW;ECsHX,cD/FU;ECgGV,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;AAiCH;AAhCG;EACC,WAAA;EACA,yBDjIU;ECkIV,4BAAA;AAkCJ;AA/BG;EACC,yBDrHS;ECsHT,mBAAA;AAiCJ;AA9BG;EACC,YAAA;AAgCJ;AA/BI;EAFD;IAGE,YAAA;EAkCH;AACF;AA9BE;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;AAgCH;AA7BE;EACC,eAAA;AA+BH;;AAxBA;EACC,cD1IY;ACqKb;;AAxBA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA2BD;;AAtBC;EACC,2BAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;AAyBF","sourcesContent":[":root {\n\t//COLORS\n\t--color-light: #f4f9ff;\n\t--color-white: #ffffff;\n\t--color-white-2: #fbfcfe;\n\n\t--color-primary: #1f68d6;\n\t--color-primary-2: #3b7ee3;\n\t--color-primary-3: #ccedff;\n\t--color-primary-4: #003c97;\n\t--color-primary-5: #0042a6;\n\t--color-primary-7: #c1daff;\n\t--color-primary-8: #97c1ff;\n\t--color-primary-09: #ccedff;\n\t--color-mima-light: #eef2f5;\n\n\t--color-error: #e12f2f;\n\t--color-success: #66b032;\n\t--color-green: #569755;\n\t--color-green-2: #92e391;\n\t--color-green-3: #d3eace;\n\t--color-yellow: #e7d788;\n\t--color-yellow-2: #ffaa00;\n\t--color-yellow-3: #8f4f00;\n\t--color-light-red: #f7d1cd;\n\t--color-deep-red: #9f0000;\n\n\t--color-grey: #b3b3c5;\n\t--color-grey-2: #d1d1d1;\n\t--color-grey-3: #e0e9f3;\n\t--color-grey-4: #d1d1d1;\n\t--color-grey-5: #ebebf5;\n\t--color-grey-6: #9898ab;\n\t--color-table-grey: #fafafc;\n\t--color-table-grey-1: #f4f4fc;\n\n\t--color-dark: #4a4a68;\n\t--color-dark-2: #1a1a42;\n\t--color-dark-3: #696365;\n\t--color-dark-6: #2a2828;\n\n\t--color-disabled: #c0c0c0;\n\t--color-light-blue: #ebf2ff;\n\t--color-light-blue-2: #d4e5ff;\n\t--color-light-blue-3: #e7f3fe;\n\n\t--color-dark-yellow: #7e6e1f;\n\t--color-light-brown: #f4f5f6;\n\t--color-light-green: #e4ffec;\n\t--color-light-yellow: #fff5d7;\n\t--color-light-red: #ffe8e8;\n\t--color-light-grey: #f3f3ff;\n\n\t--color-admin: #112855;\n\t--color-admin-2: #071530;\n\t--color-admin-3: #020710;\n\n\t// FONT\n\t--default-font-size: 1.8rem;\n\t--default-font-h1: 6.4rem;\n\t--default-font-h2: 4rem;\n\t--default-font-h3: 3.2rem;\n\t--default-font-subtitle: 2.4rem;\n\t--default-font-small: 1.4rem;\n\t--default-font-xsmall: 1.2rem;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n$color-white-2: #fbfcfe;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #ccedff;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #d1d1d1;\n$color-grey-6: #9898ab;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);\n","@import './variables/variables';\n\n.label {\n\tfont-size: $default-font-small;\n\tfont-family: inherit;\n\tpadding-left: 2rem;\n\tmargin-bottom: 1rem;\n\twidth: 100%;\n\tdisplay: flex;\n\tmax-width: 38rem;\n\n\t&__wide {\n\t\tfont-size: $default-font-small;\n\t\tfont-family: inherit;\n\t\tpadding-left: 2rem;\n\t\tmargin-bottom: 1rem;\n\t\tpadding-left: 2rem;\n\t}\n}\n\n.select {\n\tdisplay: flex;\n\twidth: 100%;\n\tflex-direction: column;\n\tmargin-top: 3rem;\n\tcolor: $color-dark;\n\n\t&__options {\n\t\tpadding: 1.5rem 2rem;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tbackground-color: $color-primary;\n\t\t\tcolor: $color-white;\n\t\t}\n\n\t\t&_selected {\n\t\t\t// color: $color-grey;\n\t\t\tpadding-left: 2rem;\n\t\t\tpadding-top: 1.9rem;\n\n\t\t\twidth: 38rem;\n\t\t\theight: 6rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: $color-white;\n\t\t\tborder: 1px solid $color-dark;\n\t\t\tdisplay: block;\n\t\t\tjustify-content: center;\n\t\t\tbox-sizing: border-box;\n\t\t\tcursor: pointer;\n\t\t\tcolor: $color-dark;\n\t\t\tmargin-top: 0.5rem;\n\t\t\tmargin-bottom: 1rem;\n\t\t\torder: 0;\n\t\t\tposition: relative;\n\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tbackground: url('../svg/arrowDown.svg');\n\t\t\t\tbackground-size: contain;\n\t\t\t\tbackground-repeat: no-repeat;\n\n\t\t\t\tposition: absolute;\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 1.6rem;\n\t\t\t\tright: 2rem;\n\t\t\t\ttop: 2.5rem;\n\n\t\t\t\ttransition: all 0.4s;\n\t\t\t}\n\n\t\t\t&__wide {\n\t\t\t\tpadding-left: 2rem;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&_active + &_selected::after {\n\t\t\ttransform: rotateX(180deg);\n\t\t\ttop: -2.5rem;\n\t\t}\n\n\t\t&_container {\n\t\t\tbackground-color: $color-white;\n\t\t\tcolor: $color-dark;\n\t\t\tborder: 1px solid $color-dark;\n\t\t\twidth: 38rem;\n\t\t\tborder-radius: 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t\torder: 1;\n\t\t\tmax-height: 27rem;\n\t\t\toverflow-y: scroll;\n\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: 1rem;\n\t\t\t\tbackground-color: $color-white;\n\t\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\t}\n\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\tbackground-color: $color-grey;\n\t\t\t\tborder-radius: 1rem;\n\t\t\t}\n\n\t\t\t&__wide {\n\t\t\t\twidth: 60rem;\n\t\t\t\t@media only screen and (max-width: 31.25em) {\n\t\t\t\t\twidth: 38rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&_active {\n\t\t\topacity: 1;\n\t\t\tmax-height: 27rem;\n\t\t\toverflow-y: scroll;\n\t\t}\n\n\t\t&_label {\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}\n\n.select2 {\n\tdisplay: flex;\n\twidth: 18rem;\n\tflex-direction: column;\n\tmargin-top: 3rem;\n\tcolor: $color-dark;\n\n\t&__options {\n\t\tpadding: 1.5rem 2rem;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tbackground-color: $color-primary;\n\t\t\tcolor: $color-white;\n\t\t}\n\n\t\t&_selected {\n\t\t\t// color: $color-grey;\n\t\t\tpadding-left: 2rem;\n\t\t\tpadding-top: 0.9rem;\n\t\t\tfont-size: var(--default-font-small);\n\t\t\twidth: 18rem;\n\t\t\theight: 4rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: $color-white;\n\t\t\tborder: 1px solid $color-dark;\n\t\t\tdisplay: block;\n\t\t\tjustify-content: center;\n\t\t\tbox-sizing: border-box;\n\t\t\tcursor: pointer;\n\t\t\tcolor: $color-dark;\n\t\t\tmargin-top: 0.5rem;\n\t\t\torder: 0;\n\t\t\tposition: relative;\n\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tbackground: url('../svg/arrowDown.svg');\n\t\t\t\tbackground-size: contain;\n\t\t\t\tbackground-repeat: no-repeat;\n\n\t\t\t\tposition: absolute;\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 1.6rem;\n\t\t\t\tright: 2rem;\n\t\t\t\ttop: 1.5rem;\n\n\t\t\t\ttransition: all 0.4s;\n\t\t\t}\n\n\t\t\t&__wide {\n\t\t\t\tpadding-left: 2rem;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&_active + &_selected::after {\n\t\t\ttransform: rotateX(180deg);\n\t\t\ttop: -2.5rem;\n\t\t}\n\n\t\t&_container {\n\t\t\tbackground-color: $color-white;\n\t\t\tcolor: $color-dark;\n\t\t\tborder: 1px solid $color-dark;\n\t\t\twidth: 18rem;\n\t\t\tborder-radius: 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t\torder: 1;\n\t\t\tmax-height: 27rem;\n\t\t\toverflow-y: scroll;\n\t\t\tfont-size: var(--default-font-small);\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: 1rem;\n\t\t\t\tbackground-color: $color-white;\n\t\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\t}\n\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\tbackground-color: $color-grey;\n\t\t\t\tborder-radius: 1rem;\n\t\t\t}\n\n\t\t\t&__wide {\n\t\t\t\twidth: 38rem;\n\t\t\t\t@media only screen and (max-width: 31.25em) {\n\t\t\t\t\twidth: 18rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&_active {\n\t\t\topacity: 1;\n\t\t\tmax-height: 27rem;\n\t\t\toverflow-y: scroll;\n\t\t}\n\n\t\t&_label {\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}\n\n// When form is filled\n\n.filled {\n\tcolor: $color-dark;\n}\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tpadding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n\tmax-width: 38rem;\n}\n\n// Success\n.success {\n\t&__h3 {\n\t\tcolor: var(--color-success);\n\t\tfont-size: var(--default-font-h3);\n\t\tfont-weight: 700;\n\t\tline-height: 3.5rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `MimaDropdown_label__Xurff`,
	"label__wide": `MimaDropdown_label__wide__72MNG`,
	"select": `MimaDropdown_select__dhfeg`,
	"select__options": `MimaDropdown_select__options__xLi7K`,
	"select__options_selected": `MimaDropdown_select__options_selected__1Ic9v`,
	"select__options_selected__wide": `MimaDropdown_select__options_selected__wide__uJhGk`,
	"select__options_active": `MimaDropdown_select__options_active__bNzTz`,
	"select__options_container": `MimaDropdown_select__options_container__KYLP5`,
	"select__options_container__wide": `MimaDropdown_select__options_container__wide__DveW-`,
	"select__options_label": `MimaDropdown_select__options_label__vZRRu`,
	"select2": `MimaDropdown_select2__WC+vJ`,
	"select2__options": `MimaDropdown_select2__options__QYoIu`,
	"select2__options_selected": `MimaDropdown_select2__options_selected__TI9ZR`,
	"select2__options_selected__wide": `MimaDropdown_select2__options_selected__wide__2eROH`,
	"select2__options_active": `MimaDropdown_select2__options_active__jr8lX`,
	"select2__options_container": `MimaDropdown_select2__options_container__qzUuM`,
	"select2__options_container__wide": `MimaDropdown_select2__options_container__wide__-+qxN`,
	"select2__options_label": `MimaDropdown_select2__options_label__7f+Pg`,
	"filled": `MimaDropdown_filled__9OL8h`,
	"error": `MimaDropdown_error__3x5pG`,
	"success__h3": `MimaDropdown_success__h3__HAymX`
};
export default ___CSS_LOADER_EXPORT___;
